import Resx from '@/components/Resx'
import React from 'react'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ModalBody } from 'reactstrap'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'

export default {
  modalProps: null,
  component: (props) =>
    <React.Fragment>
      <BasicHeader {...props} />
      <ModalBody>
        <h5 className='popup-text'><Resx name={props.content} /></h5>
      </ModalBody>
      <ConfirmFooter {...props} />
    </React.Fragment>
}



// WEBPACK FOOTER //
// ./src/dialogs/confirm.js